/**
 * Přepínače akcí odesílaných přes offline frontu.
 *
 * Endpointy v2 backend nasadil, takže jsou ve výchozím stavu zapnuté.
 * Přepínače zůstávají pro případ, že by se konkrétní akce musela za provozu
 * vypnout — třeba když se ukáže, že jedna z nich dělá na serveru neplechu
 * a nechceme kvůli tomu vracet celý build.
 */
function flag(value: string | undefined, fallback: boolean): boolean {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return fallback;
}

export const FEATURES = {
  /** POST /app/v2/scanner/scan-log – dodatečný zápis skenu, když `scanLogged` = false. */
  scanLog: flag(import.meta.env.VITE_FEATURE_SCAN_LOG, true),
  /** POST /app/v2/scanner/report-issue – hlášení dispečerům. */
  reportIssue: flag(import.meta.env.VITE_FEATURE_REPORT_ISSUE, true),
  /** POST /app/v2/scanner/transfer-confirm – potvrzení převozu. */
  transferConfirm: flag(import.meta.env.VITE_FEATURE_TRANSFER_CONFIRM, true),
  /** GET /app/v2/scanner/routes – přehled tras pro roli MASTER. */
  routesOverview: flag(import.meta.env.VITE_FEATURE_ROUTES_OVERVIEW, true),
  /**
   * GET /app/v2/scanner/overview – rozskenované zásilky pod skenerem.
   *
   * Nasazeno 16. 8. 2026, proto zapnuté. Když endpoint vrátí 403/404 (starší
   * prostředí), řádek se schová sám a skenování běží dál.
   */
  overview: flag(import.meta.env.VITE_FEATURE_OVERVIEW, true),
} as const;
